import { logEvent } from "@src/appV2/lib/analytics";
import { INTERESTED_WORK_TYPE_STORAGE_KEY } from "@src/appV2/redesign/Onboarding/components/InterestedWorkType";
import moment from "moment";

import { USER_EVENTS } from "../../../constants";
import {
  DOCUMENT_EVENTS,
  ONBOARDING_INCLUDE_EMAIL_PROPERTY_EVENTS,
  ONBOARDING_SEGMENT_EVENT_NAMES,
  PERSONAL_INFO_EVENTS,
} from "../constants/ONBOARDING_SEGMENT_EVENT_NAMES";

export interface OnboardingFunnelData {
  email?: string;
  firstName?: string;
  lastName?: string;
  preference_distance?: number;
  dob?: string;
  phone?: string;
  hcpId: string;
  hcpEventValue?: string;
  requirementId?: string;
  licenseType?: string;
  licenseExpiration?: string;
  licenseState?: string;
  licenseNumber?: string;
  didFeatureFlagGuessRegionCorrectly?: boolean;
  referralCode?: string | undefined;
}

export const fireOnboardingSegmentEvent = (eventName: string, data: OnboardingFunnelData): void => {
  try {
    const { hcpId } = data;

    const timestamp = moment().toISOString();
    const interestedWorkType =
      localStorage.getItem(INTERESTED_WORK_TYPE_STORAGE_KEY)?.replace(/^"|"$/g, "") || null;

    const {
      hcpEventValue,
      requirementId,
      licenseType,
      licenseExpiration,
      licenseState,
      licenseNumber,
      email,
      referralCode,
    } = data;

    logEvent(eventName, {
      hcpId,
      ...(PERSONAL_INFO_EVENTS.includes(eventName) ? { hcpEventValue } : {}),
      ...(ONBOARDING_INCLUDE_EMAIL_PROPERTY_EVENTS.includes(eventName) ? { email } : {}),
      ...(DOCUMENT_EVENTS.includes(eventName) ? { requirementId } : {}),
      ...(ONBOARDING_SEGMENT_EVENT_NAMES.ENTERED_LICENSE_INFORMATION
        ? { licenseType, licenseExpiration, licenseState, licenseNumber }
        : {}),
      timestamp,
      ...(interestedWorkType ? { interestedWorkType } : {}),
      ...(referralCode ? { referralCode } : {}),
    });
  } catch (error) {
    logEvent(USER_EVENTS.ONBOARDING_ERROR, {
      message: "Unable to fire segment log",
      eventName,
      agentId: data.hcpId,
    });
  }
};
